/**
 * This file handles the confetti burst on the contest page
 */

import gsap from 'gsap';
import {Physics2DPlugin} from 'gsap/Physics2DPlugin';

gsap.registerPlugin(Physics2DPlugin);

(function() {

	const contestPage = document.querySelectorAll('.contest-page');
	const mutationNode = document.getElementById('FormContainer');
	const contestSection = document.getElementById('ContestSection');

	if(contestPage.length > 0 && mutationNode) {

		const config = { childList: true, subtree: true };

		// eslint-disable-next-line func-style
		const callback = function(mutationsList, observer) {

			// Use traditional 'for loops' for IE 11
			for(const mutation of mutationsList) {

				if (mutation.type === 'childList') {

					// loop over mutations
					// check if added nodes has a length
					// if yes, check if the value has a className of wpforms-confirmation-container
					for(const node of mutation.addedNodes) {

						if(node.className === 'wpforms-confirmation-container') {

							console.log('form success');

							const offset = 80; // sticky nav height
							window.scroll({ top: (contestSection.offsetTop - offset), left: 0, behavior: 'smooth' });

							setTimeout(() => {
								formSuccessConfetti(contestSection, 2);
							}, 700);

							document.body.addEventListener( 'click', ( event ) => {
								confettiClick(event);
							} );

							observer.disconnect();

							break;

						}

					}

				}
			}
		};

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver(callback);

		// Start observing the target node for configured mutations
		observer.observe(mutationNode, config);

	}

	function confettiCreate(x, y) {
		const emitter = document.createElement('div');
		emitter.classList.add('emitter');
		emitter.style.left = x + 25 + 'px';
		emitter.style.top = y - 100 + 'px';

		document.getElementById('main').appendChild(emitter);

		particles(emitter, 90, -25, -20, 0, 360);
	}

	function formSuccessConfetti(container, amount) {

		const bounds = container.getBoundingClientRect();

		for(let i = 0; i < amount; i++) {

			const xMin = bounds.x;
			const xMax = bounds.width;
			const yMin = container.offsetTop + 80;
			const yMax = yMin + bounds.height;

			const x = gsap.utils.random(xMin, xMax);
			const y = gsap.utils.random(yMin, yMax);

			confettiCreate(x, y);

		}

	}

	function confettiClick(event) {

		const x = event.pageX;
		const y = event.pageY;

		confettiCreate(x, y);
		
	}

	function particles(parent, quantity, x, y, minAngle, maxAngle) {

		const colors = ['#FFEF46', '#1DD861', '#8B3BE3', '#005EEE', '#FD4E27'];

		for(let i = quantity - 1; i >= 0; i--) {

			const angle = gsap.utils.random(minAngle, maxAngle);
			const velocity = gsap.utils.random(70, 500);
			const dot = document.createElement('div');

			dot.style.background = colors[Math.floor(gsap.utils.random(0, 5))];

			parent.appendChild(dot);

			gsap.set(dot, { opacity: 0, x, y, scale: gsap.utils.random(0, 3) });

			let tl = gsap.timeline({
				onComplete() {
					dot.remove();
					parent.remove();
					tl.kill();
					tl = null;
				}
			})
				.to(dot, { duration: .05, opacity: 1}, 0)
				.to(dot, {
					duration: 4,
					rotationX: `-=${ gsap.utils.random(720, 1440) }`,
					rotationZ: `+=${ gsap.utils.random(720, 1440) }`,
					physics2D: { angle, velocity, gravity: 90 }
				}, 0)
				.to(dot, { duration: 1, opacity: 0 }, .8);
		}
	}
	
}());
